import { create } from 'zustand'

interface PlayerState {
  // Audio state
  isPlaying: boolean
  currentTime: number
  duration: number
  audioUrl: string | null

  // Active segment
  activeSegmentIndex: number | null

  // Seek request (forces audio sync)
  seekRequest: number | null

  // Pause request (forces audio pause)
  pauseRequest: boolean

  // Actions
  setPlaying: (playing: boolean) => void
  setCurrentTime: (time: number) => void
  setDuration: (duration: number) => void
  setAudioUrl: (url: string) => void
  setActiveSegment: (index: number | null) => void
  seekTo: (time: number) => void
  clearSeekRequest: () => void
  pause: () => void
  clearPauseRequest: () => void
}

export const usePlayerStore = create<PlayerState>((set) => ({
  isPlaying: false,
  currentTime: 0,
  duration: 0,
  audioUrl: null,
  activeSegmentIndex: null,
  seekRequest: null,
  pauseRequest: false,

  setPlaying: (playing) => set({ isPlaying: playing }),
  setCurrentTime: (time) => set({ currentTime: time }),
  setDuration: (duration) => set({ duration }),
  setAudioUrl: (url) => set({ audioUrl: url }),
  setActiveSegment: (index) => set({ activeSegmentIndex: index }),
  seekTo: (time) => set({ currentTime: time, seekRequest: time }),
  clearSeekRequest: () => set({ seekRequest: null }),
  pause: () => set({ pauseRequest: true, isPlaying: false }),
  clearPauseRequest: () => set({ pauseRequest: false }),
}))
